<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M2 21l21-9L2 3v7l15 2-15 2z" />
  </svg>
</template>

<script>
export default {
  name: 'IconSendPlane',
  props: { size: { type: [String, Number], default: 14 } },
};
</script>
